import styled from "styled-components";
import Drawer from "@mui/material/Drawer";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import TableCell from "@mui/material/TableCell";
import { withStyles } from "@mui/styles";

import { theme } from "../../config/theme";

const anchor = "right";

const StyledDrawer = styled(Drawer)`
  .MuiPaper-root {
    background: white;
    color: gray;
  }
`;

const StyledTextField = styled(TextField)`
  margin: 10px 0;
`;

const Container = styled.div`
  width: 400px;
  padding: 20px;
  background: white;

  header {
    height: 100px;

    h1 {
      margin: 0;
      font-size: 24px;
      color: #3e4343;
    }

    p {
      margin: 0;
    }
  }
`;

const BodyContainer = styled.div`
  padding: 20px;
`;

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: theme.palette.common.white,
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "0",
    color: "rgba(0,0,0,.6)"
  },
  body: {
    fontSize: 13,
    border: "0px solid white"
  }
}))(TableCell);

const StyledTableRow = withStyles(() => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

const ClickToCopy = styled.div`
  color: #0366d6;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
`;
const ActionCell = styled(StyledTableCell)`
  padding: 3px 0 0 0;
`;

export {
  anchor,
  StyledDrawer,
  StyledTextField,
  Container,
  BodyContainer,
  StyledTableCell,
  StyledTableRow,
  ClickToCopy,
  ActionCell
};
